import groq from 'groq';

import { ASSET } from './asset';
import { RICH_TEXT } from './richText';

export const PERSON = groq`
  name,
  role,
  image {
    ${ASSET},
    hotspot,
    crop
  },
  biography[] {
    ${RICH_TEXT}
  },
  "isVerified": coalesce(isVerified, false),
  slug {
    current
  }
`;
